import { ComposedChart, Legend, Line, Tooltip, XAxis, YAxis, LabelList } from 'recharts';

interface ChartItem {
  date: string;
  count: number;
}

const formatDate = (value: string) => {
  const parts = value.split('-');
  const month = parts[1];
  if (parts.length === 3) {
    return `${parts[2]}/${month}`;
  }
  return `${month}/${parts[0]}`;
};

export const DayAndMonthMedicalCertificate = ({ data }: { data: ChartItem[] }) => {
  const maxCount = Math.max(...data.map(item => item.count));

  return (
    <ComposedChart
      width={840}
      height={580}
      data={data}
      margin={{ top: 20, right: 40, bottom: 20, left: 20 }}
    >
      <XAxis
        dataKey="date"
        tickFormatter={formatDate}
        tickLine={false}
      />
      <YAxis
        domain={[0, maxCount]}
        allowDecimals={false}
        label={{ value: 'Número de Atestados', angle: -90, position: 'insideLeft', fill: '#7f8790', fontSize: 16, fontWeight: 500 }}
      />
      <Tooltip formatter={(value: number) => [`${value}`, 'Atestados']} />
      <Legend
        content={() => (
          <div style={{ display: 'flex', justifyContent: 'space-around', gap: '12px', padding: '8px 0' }}>
            <p style={{ color: '#7f8790', fontSize: 14, fontWeight: 500 }}>
              Quantidade de atestados - <strong>DIA/MÊS</strong><br/>
              <span style={{ fontSize: 12, fontWeight: 400, fontStyle: 'italic' }}>
                Identificar curva de envio de atestados
              </span>
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: 14, height: 3, backgroundColor: '#ff7300', borderRadius: 2 }} />
              <span style={{ color: '#ff7300', fontSize: 14, fontWeight: 500 }}>Atestados</span>
            </div>
          </div>
        )}
      />
      <Line
        type="monotone"
        dataKey="count"
        name="Atestados"
        stroke="#ff7300"
        strokeWidth={2}
        dot={{ fill: '#413ea0', r: 4 }}
      >
        <LabelList dataKey="count" position="top" style={{ fontSize: 12, fill: '#7f8790' }} />
      </Line>
    </ComposedChart>
  );
};